/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Removed_ToastInputs */



/**
* | output |
* | --- |
* | "Tag set removed successfully" |
*
* @param {Tags_Manager_Removed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_removed_toast = /** @type {((inputs?: Tags_Manager_Removed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Removed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ensemble de tags supprime avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Set erfolgreich entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il set di tag è stato rimosso correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Набор тегов успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conjunto de etiquetas eliminado correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签集已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグセットが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग सेट सफलतापूर्वक हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conjunto de tags removido com sucesso")
	return /** @type {LocalizedString} */ ("Tag set removed successfully")
});